import { RegistrationWorkflow } from '../../application/registration-workflow.service';
import { Component, OnInit, inject } from '@angular/core';
import { animate, style, transition, trigger } from '@angular/animations';
import { Router } from '@angular/router';
import { FormsModule } from '@angular/forms';

import { TranslatePipe } from '@ngx-translate/core';
import { SfappService } from '../../../../core/services/sfapp.service';
import { MemberStateService } from '../../application/member-state.service';
import { studioDisplay } from '../../../../shared/utils/member-helpers';

@Component({
    selector: 'app-step1',
    imports: [FormsModule, TranslatePipe],
    templateUrl: './step1.component.html',
    animations: [
        trigger('accordionSlide', [
            transition(':enter', [
                style({ height: 0, overflow: 'hidden' }),
                animate('300ms ease', style({ height: '*' })),
            ]),
            transition(':leave', [
                style({ overflow: 'hidden' }),
                animate('300ms ease', style({ height: 0 })),
            ]),
        ]),
    ]
})
export class Step1Component implements OnInit {
  private workflow = inject(RegistrationWorkflow);
  private sfapp = inject(SfappService);
  private stateService = inject(MemberStateService);
  private router = inject(Router);

  state = this.stateService.get();
  studios: any[] = [];
  locals: any[] = [];
  selectStudio: string | null = null;
  openSections: Record<string, boolean> = {};
  showTokyoSub = false;

  async ngOnInit(): Promise<void> {
    if (this.stateService.completedRegistration) {
      this.workflow.beginNew();
      this.state = this.stateService.get();
    }
    this.stateService.setVisitors(false);
    this.state.member.tmp = this.state.member.tmp ?? {};
    this.stateService.get().member.translate = 'ja';
    this.stateService.setLang('ja');

    const [locals, studios] = await Promise.all([
      this.sfapp.getLocalNumberList(),
      this.sfapp.getStudioList(),
    ]);
    this.locals = (locals ?? []).map((l: any) => ({ ...l, localNumber: Number(l.localNumber) }));
    this.studios = (studios ?? []).map((s: any) => ({ ...s, localNumber: Number(s.localNumber) }));
  }

  studioDisplay(local: any, numberOrStudios: any): boolean {
    return studioDisplay(local, numberOrStudios);
  }

  toggleSection(id: string): void {
    this.openSections[id] = !this.openSections[id];
  }

  openSection(id: string, event: Event): void {
    event.preventDefault();
    this.openSections[id] = true;
  }

  scrollToSection(id: string, event: Event, parentId?: string): void {
    event.preventDefault();
    if (parentId) this.openSections[parentId] = true;
    this.openSections[id] = true;
    const scrollTarget = parentId ?? id;
    setTimeout(() => {
      const el = document.getElementById(scrollTarget);
      if (el) el.scrollIntoView({ behavior: 'smooth' });
    }, 50);
  }

  studioClick(value: string, value2: string | null = null): void {
    this.selectStudio = value2 != null ? value + ', ' + value2 : value;
  }

  next(): void {
    if (!this.selectStudio) return;
    const parts = this.selectStudio.split(',');
    this.stateService.enterTarget(`new/${Number(parts[0])}/`);
    this.state = this.stateService.get();
    this.state.member.tmp.studio = parts;
    this.state.member.studioId = Number(parts[0]);
    this.router.navigate(['/step2']);
  }
}
